module.exports = __webpack_public_path__ + "static/media/Peerless_Platen.51a5052d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Peerless_Platen.png
// module id = 25
// module chunks = 0